import styled, { css } from 'styled-components';

export const CellWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${props => (props.alignment ? props.alignment : 'center')};
  margin: ${props => (props.overrideMargin ? props.overrideMargin : '0px')};
  padding: ${props => (props.overridePadding ? props.overridePadding : '0px')};
  flex-basis: ${props => (props.width ? `${props.width}%` : '100%')};
  font-weight: ${props => (props.weight ? props.weight : 'normal')};
  font-size: ${props => (props.size ? `${props.size}em` : '0.85em')};
  ${props => props.position && css`
    position: ${props.position};
  `}
  ${props => props.left && css`
    left: ${props.left};
  `}
  ${props => props.top && css`
    top: ${props.top};
  `}
  ${props => props.caps && css`
    text-transform: ${props.caps};
  `}
  ::selection {
    background: transparent;
  };
`;

export const CellDataDetail = styled.div`
  display: flex;
  flex-direction: ${props => (props.isSortable ? 'column' : 'row')};
  align-items: center;
  margin-top: ${props => (props.isSortable ? '6px' : '0px')};
  ${props => props.theme.mediaQueries.tablet_big_down}{
  margin-top: 0px
  }
  margin-bottom: ${props => (props.isSortable ? '8px' : '0px')};
`;

export const CellDataDetailLabel = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: ${props => (props.isSortable ? '-8px' : '0px')};
`;



// WEBPACK FOOTER //
// ./src/components/DynamicTable/TableCell/styles.js